import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../../common_components/mdae-framework";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { cloneDeep, cloneDeepWith } from "lodash";
import { GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP } from "../services/get-active-external-user-list-for-user-group";
import { SET_EXTERNAL_USER_EMAIL_PREFERENCE } from "../services/set-external-user-email-preference";
import { GET_EXTERNAL_USER_LIST } from "../services/get-external-user-list";
import { GET_BLACK_LISTED_DOMAIN } from "../services/get-black-listed-domain";
export const CONSTANT = "CONSTANT";
export const GET_EXTERNAL_USER_GROUP_LIST = "GET_EXTERNAL_USER_GROUP_LIST";
export const TOGGLE_EXTERNAL_USER_GROUP_LIST_ACTION_POPOVER =
  "TOGGLE_EXTERNAL_USER_GROUP_LIST_ACTION_POPOVER";
export const TOGGLE_EXTERNAL_USER_LIST_ACTION_POPOVER =
  "TOGGLE_EXTERNAL_USER_LIST_ACTION_POPOVER";
export const TOGGLE_ADD_EXTERNAL_USER_GROUP_POPUP =
  "TOGGLE_ADD_EXTERNAL_USER_GROUP_POPUP";
export const SET_EXTERNAL_USER_GROUP_FORM_DATA =
  "SET_EXTERNAL_USER_GROUP_FORM_DATA";
export const RESET_EXTERNAL_USER_GROUP_POPUP_VALIDATION =
  "RESET_EXTERNAL_USER_GROUP_POPUP_VALIDATION";
export const TOGGLE_UPLOAD_EXTERNAL_USER_POPUP =
  "TOGGLE_UPLOAD_EXTERNAL_USER_POPUP";
export const SET_INVALID_EXTERNAL_USER_LIST = "SET_INVALID_EXTERNAL_USER_LIST";
export const TOGGLE_EXTERNAL_USER_GROUP_POPUP =
  "TOGGLE_EXTERNAL_USER_GROUP_POPUP";
export const TOGGLE_EXTERNAL_USER_TO_GROUP_POPUP =
  "TOGGLE_EXTERNAL_USER_TO_GROUP_POPUP";
export const TOGGLE_MOVE_EXTERNAL_USER_TO_GROUP_POPUP =
  "TOGGLE_MOVE_EXTERNAL_USER_TO_GROUP_POPUP";
export const SET_EXTERNAL_USER_ASSIGNED_TO_GROUP_LIST =
  "SET_EXTERNAL_USER_ASSIGNED_TO_GROUP_LIST";
export const SET_ADD_EXTERNAL_USER_TO_GROUP_LIST =
  "SET_ADD_EXTERNAL_USER_TO_GROUP_LIST";
export const SET_OTHER_EXTERNAL_USER_GROUP_LIST =
  "SET_OTHER_EXTERNAL_USER_GROUP_LIST";
export const RESET_EXTERNAL_USER_MOVE_TO_GROUP_POPUP_VALIDATION =
  "RESET_EXTERNAL_USER_MOVE_TO_GROUP_POPUP_VALIDATION";
export const TOGGLE_EXTERNAL_USER_DETAIL_POPUP =
  "TOGGLE_EXTERNAL_USER_DETAIL_POPUP";
export const RESET_EXTERNAL_USER_DETAIL_POPUP_VALIDATION =
  "RESET_EXTERNAL_USER_DETAIL_POPUP_VALIDATION";
export const SET_EXTERNAL_USER_DETAIL_FORM_DATA =
  "SET_EXTERNAL_USER_DETAIL_FORM_DATA";
export const SET_DAILY_DIGEST_TOGGLE_VALUE = "SET_DAILY_DIGEST_TOGGLE_VALUE";
export const TOGGLE_EXTERNAL_USER_WARNING_POPUP =
  "TOGGLE_EXTERNAL_USER_WARNING_POPUP";
export const SET_EXTERNAL_USER_LINKED_DATA = "SET_EXTERNAL_USER_LINKED_DATA";
export const SET_NEW_EXTERNAL_USER_ID = "SET_NEW_EXTERNAL_USER_ID";

export const defaultExternalUserGroupFormData = {
  externalUserGroupName: "",
  description: "",
  selectedExternalUserIds: [],
  isAssignedExternalUserListChanged: false,
  externalUserGroupId: 0,
  selectedExternalUser: [],
};

export const initialExternalUserDetailFormData = {
  userStatus: "",
  registrationStatus: "",
  lastName: "",
  firstName: "",
  email: "",
  externalUserGroupName: "",
  externalUserGroupId: 0,
  accountDisabled: false,
  createdBy: "",
  createDate: "",
};

const initialError = {
  code: "",
  message: "",
  value: [],
};

const initialState = {
  loading: false,
  error: initialError,
  isLoading: false,
  externalUserGroupList: [],
  externalUserListDataGridActionPopoverTarget: null,
  isExternalUserListDataGridActionPopoverVisible: false,
  externalUserGroupFormData: { ...defaultExternalUserGroupFormData },
  selectedExternalUser: [],
  externalUserAssignedToExternalUserGroupList: [],
  externalUserGroupId: 0,
  externalUserAssignedToUserGroupList: [
    {
      externalUserName: "ABC",
      emailAddress: "skhf@jgf.com",
      userGroup: "A-Team",
    },
  ],
  invalidExternalUserList: [],
  isExternalUserDetailPopupValid: true,
  externalUserDetailFormData: { ...initialExternalUserDetailFormData },
  isDailyDigestEnabled: true,
  maxUserUploadCount: 300,
  newExternalUserId: 0,
  isCloseAddExternalUserGroupPopup:true
};
export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case CONSTANT:
    case TOGGLE_EXTERNAL_USER_GROUP_LIST_ACTION_POPOVER:
    case TOGGLE_ADD_EXTERNAL_USER_GROUP_POPUP:
    case RESET_EXTERNAL_USER_GROUP_POPUP_VALIDATION:
    case TOGGLE_EXTERNAL_USER_GROUP_POPUP:
    case TOGGLE_EXTERNAL_USER_TO_GROUP_POPUP:
    case TOGGLE_MOVE_EXTERNAL_USER_TO_GROUP_POPUP:
    case SET_EXTERNAL_USER_ASSIGNED_TO_GROUP_LIST:
    case SET_ADD_EXTERNAL_USER_TO_GROUP_LIST:
    case SET_OTHER_EXTERNAL_USER_GROUP_LIST:
    case TOGGLE_EXTERNAL_USER_LIST_ACTION_POPOVER:
    case TOGGLE_UPLOAD_EXTERNAL_USER_POPUP:
    case SET_INVALID_EXTERNAL_USER_LIST:
    case RESET_EXTERNAL_USER_MOVE_TO_GROUP_POPUP_VALIDATION:
    case RESET_EXTERNAL_USER_DETAIL_POPUP_VALIDATION:
    case SET_EXTERNAL_USER_DETAIL_FORM_DATA:
    case TOGGLE_EXTERNAL_USER_DETAIL_POPUP:
    case SET_DAILY_DIGEST_TOGGLE_VALUE:
    case TOGGLE_EXTERNAL_USER_WARNING_POPUP:
    case SET_EXTERNAL_USER_LINKED_DATA:
    case SET_NEW_EXTERNAL_USER_ID:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(state, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_EXTERNAL_USER_GROUP_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const externalUserGroupFormData = newState.externalUserGroupFormData
          ? newState.externalUserGroupFormData
          : {};
        for (let prop in action.data.externalUserGroupFormData) {
          externalUserGroupFormData[prop] =
            action.data.externalUserGroupFormData[prop];
        }
        newState = { ...newState, externalUserGroupFormData };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_EXTERNAL_USER_GROUP_LIST)(action)) {
        return { ...state, externalUserGroupList: [] };
      }
      if (isAsyncComplete(GET_EXTERNAL_USER_GROUP_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          externalUserGroupList: response.externalUserGroupList,
        };
      }
      if (
        isAsyncOperation(GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP)(action)
      ) {
        return { ...state, externalUserListForExternalUserGroup: [] };
      }
      if (
        isAsyncComplete(GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP)(action)
      ) {
        const response = action.response;
        return {
          ...state,
          externalUserListForExternalUserGroup: response.externalUserList,
        };
      }
      if (isAsyncComplete(GET_EXTERNAL_USER_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          externalUserList: response.externalUserList,
          isDailyDigestEnabled: response.isDailyDigestEnabled,
          maxUserUploadCount: response.maxUserUploadCount,
        };
      }
      if (isAsyncComplete(SET_EXTERNAL_USER_EMAIL_PREFERENCE)(action)) {
        const response = action.response;
        return {
          ...state,
          isDailyDigestEnabled: response.isDailyDigestEnabled,
        };
      }
      if (isAsyncOperation(GET_BLACK_LISTED_DOMAIN)(action)) {
        return { ...state, invalidEmailDomainList: [] };
      }
      if (isAsyncComplete(GET_BLACK_LISTED_DOMAIN)(action)) {
        const response = action.response;
        return {
          ...state,
          invalidEmailDomainList: response,
        };
      }
      return state;
    default:
      return state;
  }
};
